import { useLayoutEffect } from 'react';
import { PatientFiles } from '../../PatientFiles/PatientFiles';
import styles from './PatientProfile.module.scss';
import { PatientAlignerBlock } from './components/PatientAlignerBlock/PatientAlignerBlock';
import { PatientCaseDoctorBlock } from './components/PatientCaseDoctorBlock/PatientCaseDoctorBlock';
import { PatientComplain } from './components/PatientComplains/PatientComplains';
import { PatientDetails } from './components/PatientDetails/PatientDetails';
import { PatientLinks } from './components/PatientLinks/PatientLinks';
import { useDevice } from 'hooks';
import { selectCurrentPatientCase } from 'store/patients/selectors';
import { useSelector } from 'store/utils';

export const PatientProfile = () => {
  const { isPhone } = useDevice();

  const currentPatientCase = useSelector(selectCurrentPatientCase);

  useLayoutEffect(() => {
    isPhone && window.scrollTo(0, 0);
  }, [currentPatientCase, isPhone]);

  if (!currentPatientCase) return null;

  return (
    <div className={styles.container}>
      <PatientDetails
        firstName={currentPatientCase.firstName}
        lastName={currentPatientCase.lastName}
        taskStatusUpdatedAt={currentPatientCase.taskStatusUpdatedAt}
        id={currentPatientCase.id}
        oralHealthTherapist={currentPatientCase.oralHealthTherapist}
        task={currentPatientCase.task}
        submittedAt={currentPatientCase.submittedAt}
        isArchived={currentPatientCase.isArchived}
        isOutOfTreatment={currentPatientCase.isTaskBlocked}
        outOfTreatmentReason={currentPatientCase.taskBlockReason}
        outOfTreatmentCustomReason={currentPatientCase.taskBlockComment}
        externalPatientId={currentPatientCase.externalPatientId}
        dateOfBirth={currentPatientCase.dateOfBirth}
      />
      <PatientComplain
        id={currentPatientCase.id}
        task={currentPatientCase.task}
        isBlocked={currentPatientCase.isTaskBlocked}
      />
      <PatientCaseDoctorBlock
        id={currentPatientCase.id}
        assignDoctorID={currentPatientCase.assignedDoctorId}
        diagnosis={currentPatientCase.diagnosis}
        treatmentPlan={currentPatientCase.treatmentPlan}
        task={currentPatientCase.task}
        isBlocked={currentPatientCase.isTaskBlocked}
        isArchived={currentPatientCase.isArchived}
      />
      <PatientAlignerBlock
        id={currentPatientCase.id}
        treatmentPlanType={currentPatientCase.treatmentPlanType}
        isBlocked={currentPatientCase.isTaskBlocked}
        task={currentPatientCase.task}
        assignClinicID={currentPatientCase.clinicId}
        treatmentNote={currentPatientCase.treatmentNote}
        alignerTreatmentPlanUpperOrLowerType={currentPatientCase.alignerTreatmentPlanUpperOrLowerType}
      />
      <PatientFiles />
      <PatientLinks
        scan3dLinks={currentPatientCase.scan3dLinks}
        letterLinks={currentPatientCase.letterLinks}
        otherLinks={currentPatientCase.otherLinks}
        task={currentPatientCase.task}
        isBlocked={currentPatientCase.isTaskBlocked}
      />
    </div>
  );
};
